module.exports = __webpack_public_path__ + "assets/img/reproduction-img3-09d2acc3.jpg";